import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState } from 'react';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';
import { T as TriggerButton, a as TooltipButton, b as TooltipIcon } from './HelpTip.styles-DTMQlXk0.js';
import { u as useSurface } from '../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-1m8IJOfp.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { S as Sheet } from '../Sheet/Sheet-BWdQGx8_.js';
import { T as Tooltip } from '../Tooltip/Tooltip-DvtsSyOT.js';
import { i as infoCircle } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-t7qtQAY6-Bxh9jPb6.js';

const Trigger = ({
  renderTrigger,
  iconSize = 'medium',
  fullWidthTrigger,
  ...restProps
}) => {
  if (renderTrigger) {
    return /*#__PURE__*/React__default.createElement(TriggerButton, _extends({}, restProps, {
      $fullWidthTrigger: fullWidthTrigger,
      type: "button",
      "aria-haspopup": "dialog"
    }), renderTrigger);
  }
  return /*#__PURE__*/React__default.createElement(TooltipButton, _extends({}, restProps, {
    $fullWidthTrigger: fullWidthTrigger,
    type: "button",
    "aria-haspopup": "dialog"
  }), /*#__PURE__*/React__default.createElement(TooltipIcon, {
    type: infoCircle,
    size: iconSize
  }));
};
const HelpTip = ({
  align,
  bottomSheetProps = {},
  children,
  id = '',
  position,
  renderTrigger,
  taktId,
  taktValue,
  tooltipProps = {},
  triggerLabel = 'Open tooltip',
  triggerProps = {}
}) => {
  const isMobile = useIsMobile();
  const {
    isInverted
  } = useSurface();
  const [bottomSheetIsOpen, setBottomSheetIsOpen] = useState(false);
  return isMobile ? /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('adaptive-help-tip')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Sheet, _extends({
    closeButton: {
      type: 'icon',
      label: 'close'
    }
  }, bottomSheetProps, {
    isOpen: bottomSheetIsOpen,
    onClose: () => setBottomSheetIsOpen(false),
    side: "bottom"
  }), children), /*#__PURE__*/React__default.createElement(Trigger, _extends({}, getDataTaktAttributes({
    taktIdSuffix: 'trigger-button'
  }), triggerProps, {
    "aria-label": triggerLabel,
    onClick: () => setBottomSheetIsOpen(true),
    $inverted: isInverted,
    renderTrigger: renderTrigger
  })))) : /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('adaptive-help-tip')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(Tooltip, _extends({}, tooltipProps, {
    align: align,
    position: position,
    id: id,
    trigger: /*#__PURE__*/React__default.createElement(Trigger, _extends({}, getDataTaktAttributes({
      taktIdSuffix: 'trigger-button'
    }), triggerProps, {
      $fullWidthTrigger: triggerProps.fullWidthTrigger,
      "aria-label": triggerLabel,
      $inverted: isInverted,
      renderTrigger: renderTrigger
    })),
    fullWidthTrigger: triggerProps.fullWidthTrigger,
    message: children
  })));
};

export { HelpTip as H };
//# sourceMappingURL=HelpTip-CBpdtpZr.js.map
